import { render, staticRenderFns } from "./mainAuxPage.vue?vue&type=template&id=005a2a86&scoped=true&"
import script from "./mainAuxPage.vue?vue&type=script&lang=js&"
export * from "./mainAuxPage.vue?vue&type=script&lang=js&"
import style0 from "./mainAuxPage.vue?vue&type=style&index=0&id=005a2a86&scoped=true&lang=css&"
import style1 from "./mainAuxPage.vue?vue&type=style&index=1&id=005a2a86&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a2a86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005a2a86')) {
      api.createRecord('005a2a86', component.options)
    } else {
      api.reload('005a2a86', component.options)
    }
    module.hot.accept("./mainAuxPage.vue?vue&type=template&id=005a2a86&scoped=true&", function () {
      api.rerender('005a2a86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/mainAuxPage.vue"
export default component.exports